<template>
  <div class="header flex">
    <div
      class="box cursorPointer"
      @click="returnClientsList"
    >
      <font-awesome-icon
        :icon="['fal', 'angle-left']"
        @click="returnClientsList"
        size="2x"
      />
      <span class="u-ml5 TextWithIcon">
        得意先管理
      </span>
    </div>
    <div class="box grow" />
  </div>
</template>

<script>
export default {
  name: "AdminOrderCustomFieldHeader",
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
    /**
     * [returnClientsList description]
     */
    returnClientsList () {
      this.$router.push({
        path: "/admin/clients",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.header {
  margin: 12px 15px;
}
</style>
